import React from 'react';
import './Review.css';

const Review = ({ content }) => (
  <section className="review"><h2>{content.title} <span>{content.highlight}</span></h2><div className="review__grid">{content.cards.map(({ quote, author }) => <article key={author} className="card"><div className="quote-mark" aria-hidden="true">“</div><p className="card__quote">{quote}</p><p className="card__author">— {author}</p></article>)}</div></section>
);

export default Review;

